query CompanyMembers($id: ID!) {
  company(id: $id) {
    members {
      id
      name
      officer
    }
  }
}
